module.exports = __webpack_public_path__ + "img/logo-dark.35a49ec3.png";